import axios from 'axios'

const baseURL = 'https://eiichi.shibusawa.or.jp/api/presentations/iiif/';

export default axios.create({
  baseURL
})